export default __webpack_public_path__ + "static/media/envelope-open-solid.464110ab.svg";